module.exports = __webpack_public_path__ + "65f4284ac50277c28589f38f211d0f1f.svg";